import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
import {
  Table,
  Space,
  Breadcrumb,
  Select,
  Input,
  Button,
  Row,
  Col,
  Tag,
} from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
const { Option } = Select;
class ComponentsData extends Component {
  constructor() {
    super();
  }
  state = {
    details: [],
    newdetails: [],
    data: [],
  };

  componentDidMount() {
    const details = [];
    axios
      .get(`${getServerUrl()}/inventory/getcomponentstock/`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = res.data.data;
        const details = responsevalue;
        console.log(details);
        this.setState({ details });
      });
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  render() {
    const data = this.state.details;

    const columns = [
      {
        title: "Date",
        dataIndex: "stock_date",
        key: "stock_date",
        ...this.getColumnSearchProps("stock_date"),
      },
      {
        title: "Batch",
        dataIndex: "batch_no",
        key: "batch_no",
        ...this.getColumnSearchProps("batch_no"),
      },
      {
        title: "Componenent Name",
        dataIndex: "component_name",
        key: "component_name",

        ...this.getColumnSearchProps("component_name"),
      },
      {
        title: "Componenent No",
        dataIndex: "component_no",
        key: "component_no",

        ...this.getColumnSearchProps("component_no"),
      },
      {
        title: "Contractor",
        dataIndex: "contractor_name",
        key: "contractor_name",
        ...this.getColumnSearchProps("contractor_name"),
      },
      {
        title: "Complete Process",
        dataIndex: "process_name",
        key: "process_name",
        ...this.getColumnSearchProps("process_name"),
      },
      {
        title: "Process Desc",
        dataIndex: "processdesc",
        key: "processdesc",
        ...this.getColumnSearchProps("processdesc"),
      },

      {
        title: "Total Stock",
        dataIndex: "quantity",
        key: "quantity",
      },
      {
        title: "Completed Stock",
        dataIndex: "completed",
        key: "completed",
      },
    ];

    return (
      <div>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Inventory </Breadcrumb.Item>
          <Breadcrumb.Item>Batch Wise Component Data</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <h2 className="titles">
            BATCH WISE COMPONENT <span>DATA</span>
          </h2>

          <Space></Space>
          <br />
          <Table
            scroll={{ x: 1300 }}
            columns={columns}
            dataSource={data}
          ></Table>
        </div>
      </div>
    );
  }
}

export default ComponentsData;
